import { createSelector } from '@/redux/lib/createSelector.js';
import selectors from '@/redux/selectors/selectors';
import { getParallelLoopBlockers } from '@shared/workflow/getParallelLoopBlockers.js';
import { activeWorkflow, activeWorkflowStep } from './workflowScreenSelectors.js';

const EMPTY = Object.freeze([]);

// Same rules the runtime applies before dispatching a parallel loop. Function definitions are not
// loaded in the editor, so function steps show as unsafe here; the runtime decides with them loaded.
const parallelLoopBlockersSelector = createSelector('parallelLoopBlockers', [activeWorkflow, activeWorkflowStep, selectors.appsVersions], (workflow, step, apps) => {
  if (step?.appSlug !== 'iterate' || !workflow?.graph) {
    return EMPTY;
  }
  const blockers = getParallelLoopBlockers({ workflow, graph: workflow.graph, iterateStepId: step.id, apps });
  return blockers.length > 0 ? blockers : EMPTY;
});

export default parallelLoopBlockersSelector;
